export default "__VITE_ASSET__BBEIpKOp__"